/**
 * The /ehr questions. Plain data, so the page and the FAQPage JSON-LD that
 * the prerender puts in the page's head read the same answers.
 *
 * The page speaks to the "too good to be true" doubt: the EHR is free on its
 * own, not a trial, with no ads and no data sale. The reason given is the
 * mission, never a pricing model; the site states no price or payment model
 * for the billing service. No feature list for the EHR, and nothing that
 * dates it (no launch timing).
 */

export interface EhrFaq {
  q: string;
  a: string;
  /** Words in `a` shown as a link to `to`. */
  link?: { text: string; to: string };
}

export const EHR_FAQS: EhrFaq[] = [
  {
    q: "Is Altair's EHR really free?",
    a: "Yes. It's completely free, not a trial. There are no ads, and we never sell your data.",
  },
  {
    q: "Why is it free?",
    a: "We believe AI billing is how independent practices fight back against payers, and outdated EHRs keep practices from using it. So we built a modern EHR with AI billing built in, and made it free.",
  },
  {
    q: "Do I have to use Altair's AI billing?",
    a: "No. The EHR is free on its own. AI billing is built in, and you can turn it on whenever you're ready.",
  },
  {
    q: "Who is it for?",
    a: "We're starting with behavioral health practices, but we're expanding quickly!",
  },
  {
    q: "Is it HIPAA compliant?",
    a: "Yes. Altair is HIPAA compliant and signs a Business Associate Agreement with every practice.",
    link: { text: "HIPAA compliant", to: "/hipaa" },
  },
];

/** schema.org FAQPage for the /ehr head. */
export function ehrFaqJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    url: "https://altair-health.com/ehr",
    mainEntity: EHR_FAQS.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  };
}
